/**
 * 重定向錯誤類型
 */
export const REDIRECT_ERROR = {
  /** 沒有組織 */
  NO_ORGANIZATION: 'no_organization',
  /** 沒有權限 */
  NO_PERMISSION: 'no_permission',
  /** Fetch API 失敗 */
  FETCH_FAILED: 'fetch_failed'
} as const

export type RedirectErrorType = (typeof REDIRECT_ERROR)[keyof typeof REDIRECT_ERROR]

/**
 * 錯誤訊息設定
 */
export const ERROR_MESSAGE_CONFIG = {
  [REDIRECT_ERROR.NO_ORGANIZATION]: {
    title: '沒有公司組織',
    text: '該公司內找不到組織，請聯繫系統管理員'
  },
  [REDIRECT_ERROR.NO_PERMISSION]: {
    title: '沒有公司權限',
    text: '您沒有任何公司權限，請聯繫系統管理員'
  },
  [REDIRECT_ERROR.FETCH_FAILED]: {
    title: '載入失敗',
    text: '無法載入公司資料，請稍後再試'
  }
} as const
